(function($){
$(document).ready(function() {

    if ($('.validation-adresse').length == 1) {
        check_div_ok_livraison($('.validation-adresse').data('ok-livraison'));
    }

    $('body').on('click', '.admin_adresse', function(){
        let id = $(this).data('id'),
            type = $(this).parents('.adresse').data('type');
        let title = (id > 0) ? "Modification d'une adresse" : "Ajout d'une adresse";
        if (id == -1){
            title = "Modification de votre adresse client";
        }
        let params = {
            id: id,
            type: type
        }
        $.ajax({
            url: '/xhr-actions/admin_adresse',
            data: params,
            success: function(data) {
                $.popin.confirm( {
                    title: title,
                    message: data,
                    button: false,
                    buttonCl: "Annuler",
                    //callback: "enregistrer_adresse()",
                    callbackCl: $.popin.close
                });
            }
        });
    });

    $('body').on('click', '.jsDelAddress', function(){
      let name = $(this).data('nom-adresse');
      if(confirm('Êtes-vous sûr de vouloir supprimer cette adresse ('+name+')')) {

          let params = {
            id: $(this).data('id-adresse')
          }

          $.ajax({
            url: '/xhr-actions/supprime_adresse',
            data: params,
            success: function(data) {
              window.location.reload();
            }

          });

      }
    });

    $('body').on('change', '.choix_adresse', function(){
        let type = $(this).data('type');
        let params = {
            type: type,
            id: $(this).val()
        }
        $.ajax({
            url: '/xhr-actions/choix_adresse',
            data: params,
            success: function(data) {
                $('.adresse-'+type).html(data);
                $('#etape3 .adresse-'+type+' .modif_adresse').remove();
                $.ajax({
                    url: '/xhr-actions/ok_livraison',
                    success: function(data) {
                        $('.validation-adresse').attr('data-ok-livraison',data);
                        check_div_ok_livraison(data);
                    }
                });
            }
        });
    });

    $('body').on('click', '.valider-etape', function(){
        let etape = $(this).data('etape');
        $("#btn-etape"+(etape+1)).attr('disabled',null).trigger('click');
        let params = {
            session_value: (etape+1),
            session_name: 'etape_commande'
        }
        $.ajax({
            url: '/xhr-actions/save_session',
            data: params
        });
        let offset = $('.site-header').outerHeight();
        offset = -1 * (offset + 20);
        $(window).scrollTo($('.etapes-commande'), 200, {
            offset: offset,
            axis: 'y'
        });
    });

    $('body').on('click', '.valider-commande', function(e){
        e.preventDefault();

        if ($("#condition_vente").length == 0 || $("#condition_vente").prop("checked")) {
            let mode = $(this).data('mode');
            $("#form-commande .mode-reglement").val(mode);
            $("#form-commande").submit();
            $(".choix-mode-paiement").hide();
            $(".patientez-mode-paiement").show();
        } else {
            alert('Vous devez accepter les conditions de vente pour valider votre commande, merci.');
        }
    });


    $("body").on('click', '.usecodepromo', function(e) {
        e.preventDefault();
        // console.log('usecodepromo');
        code = $("#codepromo").val();
        montant_commande = $("#montant_hors_port").val();
        if (code == "")
            alert("Veuillez saisir un code avant de valider")
        else {
            let params = {
                code: code,
                montant_commande: montant_commande
            }
            $.ajax({
                url: '/xhr-actions/usecodepromo',
                data: params,
                success: function(data) {
                    // console.log(data);
                    if (data == "")
                        window.location.reload(true);
                    else {
                        let title = "erreur code promo";
                        $.popin.alert( {
                            title: title,
                            message: data,
                            button: false,
                            buttonCl: "Annuler",
                            //callback: "enregistrer_adresse()",
                            callbackCl: $.popin.close
                        });
                    }
                }
            });
        }
    });

    $("body").on('click', '.supcodepromo', function(e) {
        e.preventDefault();
        if(confirm("Souhaitez-vous retirer ce code promo de votre commande ?"))
         {
          $.ajax({url: '/xhr-actions/supcodepromo',
            success: function(data) {
              if(data=="")
                window.location.reload(true);
              else {
                  let title = "erreur code promo";
                  $.popin.alert( {
                      title: title,
                      message: data,
                      button: false,
                      buttonCl: "Annuler",
                      //callback: "enregistrer_adresse()",
                      callbackCl: $.popin.close
                  });
                }
              }
            })
        }
    });

    $('body').on('click', '.supprimer-compte', function(){

        let title = "Suppression de compte";

        $.ajax({
            url: '/xhr-actions/supprimer_compte_client',
            success: function(data) {
                $.popin.confirm( {
                    title: title,
                    message: data,
                    button: "supprimer mon compte",
                    buttonCl: "Annuler",
                    callback: function(){supprimer_compte_client()},
                    callbackCl: $.popin.close
                });
            }
        });
    });


    $('body').on('click', function(e){
        if (!$(e.target).closest('.panier').length && $('.mini-panier').hasClass('show')) {
            $('.client-header .panier').trigger('mouseleave');
            $('.mini-panier').removeClass('show')
        }
    })
    $('.mobile-click').on('mouseenter', function(e){
        e.stopPropagation();
    });
    $('.panier .mobile-click').on('click', function(){
        if ($('.mini-panier').hasClass('show')){
            $(this).parent().mouseenter();
        }
        else{
            $(this).parent().mouseleave();
        }
    });
    $('.compte .mobile-click').on('click', function(e){
        e.preventDefault();
        $(this).parents('.menu_item').mouseenter();
    })
    $('.mobile-click').on('mouseover', function(){
        let $div = $(this);
        setTimeout( function() {
            $div.hide()
        }, 100);
    })
    $('.client-header .panier .menu_link').on('click', function(e){
        e.preventDefault();
        if ($('.mini-panier').hasClass('show')){
            $(this).parent().mouseleave();
        }
        else{
            $(this).parent().mouseenter();
            $('.mini-panier').addClass('show');
        }
    });

    $('.tri_articles').on('change', function() {
        let params = {
            session_name: $(this).data('name'),
            session_value: $(this).val()
        };
        $.ajax({
            url : '/xhr-actions/save_session',
            data: params,
            success : function(data){
                location.reload();
            }
        });
    })

    $('.modes-affichage button').on('click', function(){
        let $btn = $(this),
            mode = $btn.data('mode');
        $btn.addClass('active').siblings().removeClass('active');
        $('.row-content').removeClass('mode-liste mode-grille maximize').addClass('mode-' + mode);
        let params = {
           session_name: 'mode_affichage',
           session_value: mode,
        };
        $.ajax({
            url: '/xhr-actions/save_session',
            data: params
        });
    });
    $('.btn-hide-col-infos').on('click', function(){
        $('.row-content').toggleClass('maximize');
    });

    $('.filter-button').on('click', function() {
        let type = $(this).data('type');

        // si type filtre Unique et filtre cliqué différent de filtre actif,
        // on removeClass('active') aux éléments du même groupe
        if ($(".filters-group-" + type).hasClass('filtre-unique') && !$('.filter-button-' + $(this).data('value')).hasClass('active')){
            $(".filters-group-" + type + " .filter-button").removeClass('active');
        }

        $(this).toggleClass('active');

        apply_filters();
    });

    $('.filter-select').on('change', function() {
        apply_filters();
    });

    $('.filtres-actifs').on('click', '.supprimer-filtre', function() {
        let type = $(this).data('type'),
            val  = $(this).data('val');

        switch (type){
            case 'button':
                $('.filter-button-' + val).click();
            break;
            case 'select':
                $('.filters-group-' + val + ' select').val('').change();
            break;
            case 'QC':
                let f = getAllUrlParams().f;
                if (f !== undefined){
                    window.location.href = window.location.pathname + "?f=" + f;
                }
                else{
                    window.location.href = window.location.pathname;
                }
            break;
        }
    });

    $('.filtres-actifs').on('click', '.supprimer-tous-les-filtres', function() {
        let qc = getAllUrlParams().qc;
        if (qc !== undefined){
            window.location.href = window.location.pathname;
        }
        else {
            $('.filters-group .active').click();
            $('.filters-group select').val('').change();
        }
    });


    $('.filters-group-title').on('click', function(){
        // console.log('ici');
        let $parent = $(this).parent();
        $parent.children('.minimized, .minizable').removeClass('minimized');
        $parent.toggleClass('minimize');
        $parent.children('.minizable').toggleClass('minimized');
    })
    $('body').on("animationend", ".minimize:not('.minimized')", function(){
        $(this).children('.minimizable').toggleClass('minimized');
    });

})
})(jQuery);


function ligne_filtre(intitule, type, val) {
  let html = '<li class="filtre-actif">\n';
  html += '<span>' + decodeURIComponent(intitule) + '</span>\n';
  html += '<button type="button" class="supprimer-filtre" data-type="' + type + '" data-val="' + val + '"><span class="sr-only">supprimer</span><i class="icon-x"></i></button>\n';
  html += '</li>';
  return html;
}

function apply_filters() {
    let qc = getAllUrlParams().qc,
        queryString = '?f=',
        filters = new Array(),
        filtersValue = new Array(),
        filtresActifsHtml = '',
        nbFiltresActifs = 0;

    if (qc !== undefined) {
        queryString = '?qc=' + qc + '&f=';
        filtresActifsHtml = filtresActifsHtml + ligne_filtre(qc, "QC", qc);
        nbFiltresActifs++;
    }

    $('.filter-button.active').each(function() {
        let type  = $(this).data('type'),
            value = $(this).data('value'),
            title = $(this).data('title');
        if (typeof filters[type] == 'undefined')
            filters[type] = new Array();
        filters[type].push(value);
        filtresActifsHtml += ligne_filtre(title, "button", value);
    });
    $('.filter-select').each(function() {
        let $optSelected = $(this).children("option:selected"),
            type  = $optSelected.data('type'),
            value = $optSelected.val(),
            title = $optSelected.data('title');
        if (value != '') {
            if (typeof filters[type] == 'undefined')
                filters[type] = new Array();
            filters[type].push(value);
            filtresActifsHtml += ligne_filtre(title, "select", type);
        }
    });
    let nbFiltres = 0;
    for (let type in filters) {
        nbFiltres++;
        filters[type].forEach(function(value, i) {
            filtersValue.push(value);
            nbFiltresActifs++;
        });
    }
    queryString += filtersValue.join('-');

    const $produits = $('.filtrable .produit');

    if (nbFiltres == 0) {
        $produits.removeClass('filter-out');
        if (qc === undefined) {
            $('.filtres-actifs .filters-list').html("");
            $('.filtres-actifs').addClass('hidden');
            window.history.pushState({}, document.title, window.location.pathname);
        } else {
            $('.filtres-actifs .filters-list').html(filtresActifsHtml);
            history.pushState({}, null, "?qc="+qc);
        }
    }
    else {
        $produits.each(function() {
            let $produit = $(this);
            let tags = $(this).data('tags').split(" ");
            let trouve = 0;
            for (let type in filters) {
                let ok = true;
                filters[type].forEach(function(value, i) {
                    if ($.inArray(value, tags) != -1 && ok) {
                        trouve++;
                        ok = false;
                    }
                });
            }
            if (trouve == nbFiltres){
                $produit.addClass("show");
            }
        });
        $produits.not('.show').addClass('filter-out');

        $('.show').removeClass(["filter-out", "hidden"]);
        $produits.removeClass("show");

        $('.filtres-actifs .filters-list').html(filtresActifsHtml);
        $('.filtres-actifs').removeClass('hidden');
        $(".filtre-caches").val(filtersValue.join('-'));
        history.pushState({}, null, queryString);
    }
    $('.filtres-actifs .nbFiltres').html(' (' + nbFiltresActifs + ')');
    let nbArticles = $produits.not('.filter-out').length;
    let nbProduitsHtml = nbArticles + ' produit';
    nbProduitsHtml += (nbArticles > 1) ? 's' : '';
    $('.nb-produits span').html(nbProduitsHtml);

    let params = {
        qc: qc,
        f: filtersValue.join('-')
    }
    $.ajax({
        url : '/xhr-actions/save_filters',
        data: params
    });
}

function check_div_ok_livraison(ok) {
    if (ok) {
        $('.ok-livraison').show();
        $('.not-ok-livraison').hide();
    } else {
        $('.ok-livraison').hide();
        $('.not-ok-livraison').show();
    }
}

function supprimer_compte_client() {
    $.ajax({
        url: '/xhr-actions/supprimer_compte_client_confirme',
        success: function(data) {
            window.location.href = data;
        }
    });
}
